<template>
  <dialog ref="dialog" class="slotmodal" aria-labelledby="mega-slot-title" @close="$emit('isSlot')">
    <h3 id="mega-slot-title">{{ codeName }}<button type="button" class="close" aria-label="슬롯 목록 닫기" autofocus @click="$emit('isSlot')"><img src="@/assets/img/icon_cancel.png" alt="" /></button></h3>
    <div class="slotmodalwrap">
        <p v-if="isLoading" class="slot-status" role="status">게임을 불러오는 중입니다.</p>
        <p v-else-if="!list.flat().length" class="slot-status" role="status">{{ loadError || '현재 이용 가능한 게임이 없습니다.' }}</p>
        <ul>
          <template v-for="(item, index) in list" v-bind:key="index">
             <template v-for="subItem in item" v-bind:key="subItem.id">
               <li>
                 <button type="button" @click="setSlotGame(subItem)">
                   <img :src="subItem.image" alt="" loading="lazy" />
                   <span class="sname">{{ (subItem.names && (subItem.names[$i18n.locale] || subItem.names.ko || subItem.names.en)) || subItem.name || subItem.key }}</span>
                 </button>
               </li>
             </template>
          </template>
        </ul>
    </div>
  </dialog>
</template>

<script>
import { getGameSlotList } from '@/api/game'
import { mapState } from 'vuex'

export default {
  name: 'SlotList',
  props: [
    'groupCode',
    'codeName',
    'code'
  ],
  data () {
    return {
      list: [],
      isLoading: true,
      loadError: ''
    }
  },
  created () {
    if (this.groupCode && this.codeName) {
      this.loadSlotList()
    }
  },
  mounted () {
    this.$refs.dialog.showModal()
  },
  computed: {
    ...mapState([
      'userData'
    ])
  },
  watch: {
    codeName () {
      if (this.groupCode && this.codeName) {
        this.loadSlotList()
      }
    }
  },
  methods: {
    async setSlotGame (item) {
      const gameKey = item.key
      const codeInfo = this.code ? this.commonCodeByCode[this.code] : this.commonCode[this.groupCode][this.codeName]
      const params = {
        vendorKey: codeInfo.code.toString(),
        gameType: codeInfo.groupCode.toString(),
        gameKey: gameKey
      }
      if (this.userData) {
        if (codeInfo.codeName.indexOf('H-') > -1) {
          // hotel
          await this.onSlotSelectGame(params)
        } else {
          await this.onGetGame(params)
        }
      } else {
        await this.onCheck('front.error.afterSignin')
      }
    },
    async loadSlotList () {
      this.list = []
      this.isLoading = true
      this.loadError = ''
      this.emitter.emit('Loading', true)
      try {
        const params = await this.onSelectGame(this.groupCode, this.codeName)
        if (!params) return
        if (this.codeName.indexOf('H-') > -1) {
          this.list = [[
            { category: 'slot', key: 'SLOT01', image: require('@/assets/img/game_h-slot_pc_1.jpg') },
            { category: 'slot', key: 'SLOT02', image: require('@/assets/img/game_h-slot_pc_2.jpg') }
          ]]
        } else {
          const { data } = await getGameSlotList(params)
          if (data.resultCode !== '0') {
            this.loadError = data.resultMessage || '게임 목록을 불러오지 못했습니다.'
          } else {
            this.list = [data.data.games || []]
          }
        }
      } catch {
        this.loadError = '게임 목록을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.'
      } finally {
        this.isLoading = false
        this.emitter.emit('Loading', false)
      }
    }
  }
}
</script>

<style scoped>
.slotmodal { position: fixed; z-index: 120; left: 50%; top: 50%; margin: 0; padding: 0; transform: translate(-50%, -50%); width: min(960px, calc(100% - 28px)); max-height: calc(100dvh - 40px); border: 1px solid #91ded3; border-right-color: #a282da; border-bottom-color: #a282da; border-radius: 12px; background: #202120; color: #eee; box-shadow: 0 10px 40px #0008; overflow: hidden; }
.slotmodal::backdrop { background: #000a; }
.slotmodal h3 { position: relative; padding: 20px 60px 20px 20px; color: #b4eddf; font-size: 20px; font-weight: 700; line-height: 1.3; border-bottom: 1px solid #464746; }
.close { position: absolute; right: 10px; top: 10px; width: 44px; height: 44px; padding: 10px; border: 0; background: none; cursor: pointer; }
.close img { width: 100%; height: 100%; }
.slotmodalwrap { max-height: calc(100dvh - 130px); overflow-y: auto; padding: 20px; }
.slotmodalwrap ul { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 20px 14px; }
.slotmodalwrap li { min-width: 0; }
.slotmodalwrap li button { width: 100%; padding: 0; border: 0; background: none; color: #eee; cursor: pointer; }
.slotmodalwrap li img { width: 100%; aspect-ratio: 1.2; object-fit: cover; border: 1px solid #727477; border-radius: 8px; box-sizing: border-box; }
.sname { display: block; margin-top: 8px; line-height: 1.4; font-size: 13px; }
.slotmodal button:focus-visible { outline: 2px solid #b4eddf; outline-offset: 2px; }
.slotmodalwrap li button:hover img { border-color: #b4eddf; filter: brightness(1.1); }
.slot-status { padding: 40px 12px; text-align: center; line-height: 1.6; font-size: 14px; }
@media (max-width: 600px) {
  .slotmodalwrap ul { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .slotmodal h3 { font-size: 17px; }
  .slotmodalwrap { padding: 14px; }
}
</style>
